'use strict';

export default function dnAnalyticsTagLoader(dn) {

  // 開発環境（ローカル）ではロードしない
  if (dn.$store.getters['config/envIs']('develop')) return;

  // DN2016から入っているGTMタグ（GTM-KTG5RS）
  // BC社で設置されているようで、利用意図は不明との事
  // <!-- Google Tag Manager -->
  // <noscript><iframe src="//www.googletagmanager.com/ns.html?id=GTM-KTG5RS" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KTG5RS');</script>
  // <!-- End Google Tag Manager -->
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KTG5RS');

  // DN2018の申し送り時から挿入するGTMタグ（GTM-PRBP28N）
  // 上記BC用のタグと並行して利用するとの事
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PRBP28N');

  /**
   * DN2019新規追加 GTM (GTM-P63NX4T)
   * @todo
   *   上記の2つは2019/3の年度更新時に削除する事（こっちだけになる）
   */

  // ※オリジナルコード
  // <!-- Google Tag Manager -->
  // <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  // })(window,document,'script','dataLayer','GTM-P63NX4T');</script>
  // <!-- End Google Tag Manager -->
  //
  // <!-- Google Tag Manager (noscript) -->
  // <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P63NX4T"
  // height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  // <!-- End Google Tag Manager (noscript) -->
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-P63NX4T');
}



// WEBPACK FOOTER //
// ./src/js/util/dn-analytics-tag-loader.js